import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Row,
  Col,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import "./Login.scss"
import logolight from "../../assets/images/companies/froth_logo_full.png"
import logoMain from "../../assets/main_logo.png"

// redux
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "components/Common/withRouter"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { toast } from "react-toastify"

const DomainLogin = props => {
  // const { instance } = useMsal();

  const [loading, setLoading] = useState(false)
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      domain: "",
    },
    validationSchema: Yup.object({
      domain: Yup.string()
        .matches(
          /^[a-zA-Z0-9]+$/,
          "* only letters and numbers are allowed\n* space and special characters are not allowed"
        )
        .required("Domain required"),
    }),

    onSubmit: values => {
      getToken(values.domain)
    },
  })

  const handleLoginClick = e => {
    e.preventDefault()
    const values = validation.values
    validation.handleSubmit(values)
  }

  const LoginProperties = createSelector(
    state => state.Login,
    login => ({
      error: login.error,
    })
  )

  const { error } = useSelector(LoginProperties)

  const handleDomain = dataN => {
    const url =
      dataN.startsWith("http://") || dataN.startsWith("https://")
        ? dataN
        : `https://${dataN}`

    window.open(url, "_self")
  }

  const getToken = async data => {
    setLoading(true)
    const trimmedData = data.trim()
    const domainName = trimmedData.includes(".frothtestops.com")
      ? trimmedData
      : `${trimmedData}.frothtestops.com`

    try {
      const response = await fetch(
        `https://rd-adminportal.frothtestops.com/api/customers/organization/by-domain/?domain=${domainName}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      const dataResponse = await response.json()
      if (dataResponse.status) {
        handleDomain(domainName)
      } else {
        toast.error(dataResponse?.message, {
          position: "top-right",
          autoClose: 2000,
        })
      }
    } catch (error) {
      console.error("Error during login:", error)
    }
    setLoading(false)
  }

  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={3}
              className="carousel-hide d-md-none  d-xl-flex flex-column align-items-center"
              style={{ background: "rgb(210, 217, 255)" }}
            >
              <div className="">
                <div
                  className="d-flex justify-content-left h-1 mt-2"
                  style={{
                    marginBottom: "9rem",
                  }}
                >
                  <img
                    src={logoMain}
                    alt=""
                    height="77"
                    style={{ marginLeft: "4.5rem" }}
                    className="logo-dark-element mt-3"
                  />

                  <img
                    src={logoMain}
                    alt=""
                    height="77"
                    className="logo-light-element"
                  />
                </div>
                <div className="fs-2 p-2 text-primary ms-2">
                  <i className="bx bxs-quote-alt-left" /> Streamline project
                  requirements, testing and automation{" "}
                  <i className="bx bxs-quote-alt-right" />
                </div>
              </div>
            </Col>
            <div className="col-2"></div>
            <Col xl={5}>
              <div className="auth-full-page-content p-md-4 p-2 align-items-center">
                <div className="w-100">
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      marginLeft: "-24px",
                      marginTop: "-18px",
                      marginBottom: "-15px",
                    }}
                  >
                    <img
                      src={logoMain}
                      alt=""
                      height="75"
                      className="logo-dark-element"
                    />
                    <img
                      src={logoMain}
                      alt=""
                      height="75"
                      className="logo-light-element"
                    />
                  </div>
                  <div className="d-flex flex-column fs-6 h-100 mt-2">
                    <div className="my-auto mt-1">
                      <h3 className="text-primary">Login</h3>
                      <div className="mt-3">
                        <Form className="form-horizontal mb-5">
                          {error ? <Alert color="danger">{error}</Alert> : null}
                          <div className="mb-3">
                            <Label className="form-label">
                              Domain
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="domain"
                              className="form-control"
                              placeholder="Trial users can log in by entering 'demo'"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.domain || ""}
                              invalid={
                                validation.touched.domain &&
                                validation.errors.domain
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.domain &&
                              validation.errors.domain && (
                                <FormFeedback type="invalid">
                                  {validation.errors.domain
                                    .split("\n")
                                    .map((line, index) => (
                                      <React.Fragment key={index}>
                                        {line}
                                        <br />{" "}
                                        {/* Line break between each message */}
                                      </React.Fragment>
                                    ))}
                                </FormFeedback>
                              )}
                          </div>
                          <div className="mt-2 d-grid">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                              onClick={handleLoginClick}
                            >
                              {loading ? "Loading..." : "Proceed"}
                            </button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(DomainLogin)

DomainLogin.propTypes = {
  history: PropTypes.object,
}
